exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._3AAltSLwok9bXisg1Qn04W{margin-top:10px}._1cVu_Mxv5P7qhj_m_vF4E8{width:400px}", ""]);

// exports
exports.locals = {
	"checkbox": "_3AAltSLwok9bXisg1Qn04W",
	"textbox": "_1cVu_Mxv5P7qhj_m_vF4E8"
};